<template>
  <div class="pago" id="style-1">
    <h4><i class="icon-card"></i> Información del pago</h4>
    <div class="contenedorPago1">
      <table class="table table-items" style="margin-bottom: 0px">
        <div
          v-if="info === null"
          v-loading="true"
          element-loading-text="Cargando..."
          element-loading-spinner="el-icon-loading"
          style="height: 100px"
        ></div>
        <template v-else-if="info">
          <tr>
            <th style="padding-left: 5px">Medio de pago</th>
            <td>
              <span
                v-for="(m, i) in medioPago"
                :key="i"
                :style="[
                  !i && medioPago.length == 2
                    ? { 'border-bottom': '1px solid #D0D0D0' }
                    : { 'border-bottom': 'none' },
                ]"
              >
                {{ m }}
              </span>
            </td>
          </tr>
          <tr>
            <th style="padding-left: 5px">Subtotal</th>
            <td>{{ subTotal | currency }}</td>
          </tr>
          <tr v-if="descuento">
            <th style="padding-left: 5px">Promociones / Ofertas</th>
            <td>{{ descuento | currency }}</td>
          </tr>
          <tr v-if="envio > 0">
            <th style="padding-left: 5px">Costo del envío</th>
            <td>{{ envio | currency }}</td>
          </tr>
          <tr>
            <th style="padding-left: 5px; padding-bottom: 15px">Total del pedido</th>
            <td style="padding-bottom: 15px">
              {{ totalPedido | currency }}
              <span v-if="devuelto">**</span>
            </td>
          </tr>
          <tr v-if="valorCuota.length" class="trForma">
            <th style="padding-left: 5px">Forma de pago</th>
            <!-- <td> {{cuotas}} cuotas de {{ valorCuota |  currency('$', 2, {thousandsSeparator: '.', decimalSeparator: ',' })}}</td> -->
            <td style="flex-direction: column">
              <div
                v-for="(vc, i) in valorCuota"
                :key="i"
                :style="[
                  !i && valorCuota.length == 2
                    ? { 'border-bottom': '1px solid #D0D0D0' }
                    : { 'border-bottom': 'none' },
                ]"
              >
                {{ cuotas }} cuotas de {{ vc | currency }}
                <span v-if="valorCuota.length == 2">
                  - {{ tarjetas[i].sistema_pago }} ({{ tarjetas[i].ult_digitos }})
                </span>
              </div>
            </td>
          </tr>
        </template>

        <template v-else>
          <tr v-if="info === 0">
            <td colspan="2" style="text-align: center">
              No se encontró información del pago.
            </td>
          </tr>
        </template>
      </table>
      <div
        style="
          text-align: left;
          font-size: 12px;
          line-height: 1;
          padding: 15px 0px 0px 15px;
          color: #333;
        "
      >
        <span v-if="descuento" >
          * Esta compra incluye descuentos adicionales, los podrás ver en el detalle del
          pedido.
        </span>
       
        <span v-if="devuelto">
           <br>
          ** no incluye devoluciones.
        </span>
      </div>
    </div>

    <InformacionDevolucion v-if="devuelto" :datos="infoDev" />
    <div class="mb100"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// import { HTTP } from "@/axios.js"
import { MEDIO_PAGO } from "../helpers/helpers";

export default {
  props: ["datos"],
  components: {
    InformacionDevolucion: () =>
      import(
        /* webpackChunkName: "InformacionDevolucion" */ "@/components/informacionDevolucion"
      ),
  },
  name: "InformacionPago",
  data() {
    return {
      info: null,
      subTotal: null,
      descuento: null,
      envio: null,
      devuelto: null,
      cuotas: null,
      medioPago: [],
      totalPedido: null,
      valorCuota: [],
      infoDev: {},
      tarjetas: null,
    };
  },
  watch: {
    //   $route (to, from){
    //     console.log('to',to.params.pedido);
    //     console.log('from',from.params.pedido);
    //     if(to.params.pedido != from.params.pedido){
    //         this.getInformacionPago2()
    //     }
    //   },
  },
  mounted() {
    console.log("id vtex", this.pedido);
    this.getInformacionPago2();
  },

  methods: {
    getInformacionPago2() {
      const { pago, tarjetas, reembolso, devoluciones, seguimiento } = this.datos.pago;
      this.medioPago = [];
      this.valorCuota = [];
      console.log("reembolso", reembolso);
      this.tarjetas = tarjetas.filter((t) => t !== null);
      this.info = pago.length;
      this.cuotas = pago[0].cuotas ? pago[0].cuotas : 0;
      this.subTotal = pago[0].sub_total ? pago[0].sub_total : 0;
      this.descuento = pago[0].descuentos ? parseFloat(pago[0].descuentos) : 0;
      this.envio = pago[0].costo_envio ? pago[0].costo_envio : 0;
      this.devuelto = parseFloat(reembolso) ? parseFloat(reembolso) : 0;

      this.tarjetas.forEach((tarjeta) => {
        this.medioPago.push(
          `${MEDIO_PAGO[tarjeta.grupo_pago]} ${
            tarjeta.sistema_pago ? tarjeta.sistema_pago : ""
          } (${tarjeta.ult_digitos ? tarjeta.ult_digitos : " "})`
        );
        this.valorCuota.push(
          parseFloat(tarjeta.valor_pago) / 100 / parseFloat(tarjeta.cuotas_pago)
        );
      });

      this.totalPedido = parseFloat(pago[0].sub_total) + parseFloat(pago[0].descuentos);

      if (!tarjetas)
        this.valorCuota =
          (parseFloat(pago[0].sub_total) + parseFloat(pago[0].descuentos)) /
          parseFloat(pago[0].cuotas);

      this.infoDev.datosDevolucion = devoluciones;
      this.infoDev.fechaDevolucion = pago[0].fecha_dev
        ? this.$date(pago[0].fecha_dev.date).format("DD/MM/YYYY HH:mm")
        : "";
      this.infoDev.motivoDevolucion = pago[0].razon_dev;
      this.infoDev.devuelto = this.devuelto;
      this.infoDev.total = this.totalPedido - reembolso;
      this.infoDev.seguimiento = seguimiento;
    },
  },
};
</script>

<style scoped>
.pago {
  margin: 20px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  height: 510px;
  margin-bottom: 0;
}
.pago h4 {
  margin: 0;
  text-align: left;
  margin-bottom: 10px;
}
tr.trForma > th {
  padding: 15px 0 !important;
  background-color: #f7f6cf !important;
  font-weight: bold !important;
}
tr.trForma > td {
  background-color: #f7f6cf !important;
  /* padding: 10px !important; */
  color: #333;
  font-weight: bold !important;
}
.contenedorPago1 {
  border: 2px solid #e9e9e9;
  /* padding: 10px; */
  padding-top: 20px;
  padding-bottom: 5px;
  border-radius: 4px;
}
.table-items {
  padding: 10px !important;
}
.table-items > tr > th {
  padding: 1px;
  width: 180px;
  color: #333;
  padding: 1px 20px;
  padding-left: 20px !important;
  font-weight: normal;
}
.table-items > tr > td {
  padding: 1px;
  text-align: justify;
  color: #333;
  padding: 1px 20px;
  /* padding-left: 10px; */
}

@media screen and (max-width: 768px) {
  .pago {
    margin: 5px 3px;
    height: 100vh;
    
  }
  .mb100 {
    margin-bottom: 150px;
  }
  .table-items > tr > th {
    padding: 2px;
    width: 160px;
  }
  .table-items > tr > td {
    padding: 2px;
    text-align: justify;
  }
  .contenedorPago1 {
    padding: 0px;
    padding-bottom: 10px;
  }
  .table-items > tr > th {
    padding: 1px;
    width: 160px;
    color: #333;
    padding: 1px 0px;
    padding-left: 10px !important;
    font-weight: normal;
    font-size:13px;
}
.table-items > tr > td {
  padding: 1px;
  text-align: left;
  color: #333;
  padding: 1px 0px;
    font-size:13px;

  /* padding-left: 10px; */
}
}
</style>
